// The Jody mark plus the wordmark, from the jody-landing-page repo
// (src/components/Logo.tsx), rebuilt from Kristian's 178x60 logo PNGs so it
// stays sharp on high-density screens. The landing copy also has an `inverse`
// variant for its dark footer; the app has no dark surface yet.
export const Logo = () => (
  <span className="flex items-center gap-3.5">
    <img src="/jody-mark.png" alt="" className="h-8 w-8" />
    <span className="text-[22px] font-extrabold leading-none tracking-[-0.02em] text-[#005a26]">Jody</span>
  </span>
);
